import { render, staticRenderFns } from "./TKListView.vue?vue&type=template&id=70763070&scoped=true&"
import script from "./TKListView.vue?vue&type=script&lang=ts&"
export * from "./TKListView.vue?vue&type=script&lang=ts&"
import style0 from "./TKListView.vue?vue&type=style&index=0&id=70763070&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70763070",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow,VSpacer})
